module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/cms-panel-active.c8b37189.svg";